import { Link } from "@inertiajs/react"

interface ContactTypeOption {
  id: number
  name: string
}

interface ContactFormData {
  contact_type_id: number | null
  category: string
  info: string
  notes: string
  sort_order: number
}

interface Props {
  caseId: number
  data: ContactFormData
  setData: (key: keyof ContactFormData, value: string | number | null) => void
  errors?: Record<string, string[]>
  processing: boolean
  onSubmit: (e: React.FormEvent) => void
  submitLabel: string
  contact_types: ContactTypeOption[]
}

export default function ContactForm({
  caseId,
  data,
  setData,
  errors,
  processing,
  onSubmit,
  submitLabel,
  contact_types,
}: Props) {
  return (
    <form onSubmit={onSubmit} className="max-w-3xl">
      <div className="mb-4">
        <label htmlFor="contact_type_id" className="mb-1 block font-medium">
          Type
        </label>
        <select
          id="contact_type_id"
          value={data.contact_type_id ?? ""}
          onChange={(e) =>
            setData(
              "contact_type_id",
              e.target.value ? parseInt(e.target.value) : null,
            )
          }
          className="border-hpi-light-gray w-full rounded border px-3 py-2"
        >
          <option value="">Select type...</option>
          {contact_types.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
        {errors?.contact_type_id && (
          <p className="text-hpi-red mt-1 text-sm">
            {errors.contact_type_id.join(", ")}
          </p>
        )}
      </div>

      <div className="mb-4">
        <label htmlFor="info" className="mb-1 block font-medium">
          Info
        </label>
        <input
          type="text"
          id="info"
          value={data.info}
          onChange={(e) => setData("info", e.target.value)}
          className="border-hpi-light-gray w-full rounded border px-3 py-2"
          required
        />
        {errors?.info && (
          <p className="text-hpi-red mt-1 text-sm">{errors.info.join(", ")}</p>
        )}
      </div>

      <div className="mb-4">
        <label htmlFor="notes" className="mb-1 block font-medium">
          Notes
        </label>
        <textarea
          id="notes"
          value={data.notes}
          onChange={(e) => setData("notes", e.target.value)}
          className="border-hpi-light-gray w-full rounded border px-3 py-2"
          rows={4}
        />
        {errors?.notes && (
          <p className="text-hpi-red mt-1 text-sm">{errors.notes.join(", ")}</p>
        )}
      </div>

      <div className="flex gap-2">
        <button
          type="submit"
          disabled={processing}
          className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white disabled:opacity-50"
        >
          {submitLabel}
        </button>
        <Link
          href={`/cases/${caseId}/contacts`}
          className="border-hpi-light-gray hover:bg-hpi-pale-blue rounded border px-4 py-2"
        >
          Cancel
        </Link>
      </div>
    </form>
  )
}
